
import $ from 'jquery';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import DatePickerRange from './DatePickerRange.vue';

@Component({
    components: {
        DatePickerRange
    }
})
export default class FilterByDateRange extends Vue {
    
    @Prop({default: false}) visible: boolean;
    /** Active range from parent (e.g. restored filters) so the modal pickers show the same dates. */
    @Prop({ default: () => [] }) storedDateRange: any[];
    modalTitle: string = 'Filtrar por rango de fecha'
    dateRangeSelected: any = [];

    formatDateForBackend(dateString: string): string {
        if (!dateString) return '';
        
        // If date is already in correct format, return it
        if (dateString.includes('T')) {
            return dateString;
        }
        
        // Convert date to YYYY-MM-DDTHH:mm:ss format
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return dateString;
        }
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    @Emit()
    closeModal(item) {}

    @Emit()
    clearFilterByDateRange(){
        this.updateRangeDate([]);
        this.closeModal(null);
        return []
    }
    
    @Emit()
    updateFilterDateRange(){
        let datePicker = this.$refs.datepickrange as any;
        let startDate = datePicker.getStartDate;
        let endDate = datePicker.getEndDate;
        
        // Format dates for backend
        const formattedStartDate = this.formatDateForBackend(startDate);
        const formattedEndDate = this.formatDateForBackend(endDate);
        
        this.updateRangeDate([formattedStartDate, formattedEndDate]);
        this.closeModal(null);
        
        return [formattedStartDate, formattedEndDate]
    }

    updateRangeDate(value) {
       this.dateRangeSelected = [];
       this.dateRangeSelected = value;
    }

    /** Keep modal DatePickerRange in sync with parent filters (restore, apply, clear). */
    syncDateRangeFromParent() {
        const s = this.storedDateRange;
        if (s && s.length >= 2 && s[0] !== '' && s[1] !== '' && s[0] != null && s[1] != null) {
            this.dateRangeSelected = [String(s[0]), String(s[1])];
        } else {
            this.dateRangeSelected = [];
        }
    }

    @Watch('visible')
    onVisibleChange(open: boolean) {
        if (open) {
            this.$nextTick(() => {
                this.syncDateRangeFromParent();
            });
        }
    }

    @Watch('storedDateRange', { deep: true })
    onStoredDateRangeChange() {
        if (this.visible) {
            this.$nextTick(() => {
                this.syncDateRangeFromParent();
            });
        }
    }

    mounted() {
        this.syncDateRangeFromParent();
    }
}
